import {
  GetComponentsEntityTypeEnum,
  useGetCustomizeableComponents,
} from '../../../hooks/useGetDashboardCustomizeableComponents';
import { MdLanguage, MdStyle } from 'react-icons/md';
import React, { useEffect } from 'react';
import SettingsTab, { SettingsTabOption } from '../../../components/SettingsTab';

import { CustomizeComponentEnum } from '../../../util/jsonEditorUtils/types/CustomizeComponent.enum';
import CustomizeKioskLocalization from './Settings/CustomizeLocalization/CustomizeKioskLocalization';
import CustomizeKioskTheme from './Settings/CustomizeTheme/CustomizeKioskTheme';
import { CustomizeSettingsEnum } from '../../../util/jsonEditorUtils/types/CustomizeSettings.enum';
import { LoadingSpinner } from '../../../components/LoadingSpinner';
import { getCustomizationTabsPerSettingsAndComponent } from '../../../util/jsonEditorUtils/getCustomizationSettings';
import { useParams } from 'react-router-dom';

const KioskSettingsTab: React.FC<{}> = () => {
  const { kioskId } = useParams<{ kioskId: string }>();

  const { isLoading, query, data: componentsData } = useGetCustomizeableComponents(
    GetComponentsEntityTypeEnum.KIOSK
  );

  useEffect(() => {
    query(kioskId);
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const getComponentBasedOnSettingAndComponent = (
    settings: CustomizeSettingsEnum,
    component: CustomizeComponentEnum
  ): SettingsTabOption | undefined => {
    const themeSettingsTabs = new Map([
      [
        CustomizeComponentEnum.KIOSK,
        {
          Component: CustomizeKioskTheme,
          icon: MdStyle,
          key: `${component}-${settings}-CUSTOMIZATION`,
          value: 'Customize kiosk theme',
        },
      ],
    ]);

    const localizationSettingsTabs = new Map([
      [
        CustomizeComponentEnum.KIOSK,
        {
          Component: CustomizeKioskLocalization,
          icon: MdLanguage,
          key: `${component}-${settings}-CUSTOMIZATION`,
          value: 'Customize kiosk localization',
        },
      ],
    ]);

    switch (settings) {
      case CustomizeSettingsEnum.THEME:
        return themeSettingsTabs.get(component);
      case CustomizeSettingsEnum.LOCALIZATION:
        return localizationSettingsTabs.get(component);
      default:
        return undefined;
    }
  };

  return (
    <SettingsTab
      tabs={getCustomizationTabsPerSettingsAndComponent({
        componentsData,
        getComponentBasedOnSettingAndComponent,
      })}
    />
  );
};

export default KioskSettingsTab;
